import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import {Button, Grid, Typography, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { AppRoutes } from '../axios/endPoints';
import { List, ListItem } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Header } from './common/Header';
import parse from 'html-react-parser';
import '../styles/About.css'

const About = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
    <Card style={{marginTop: '5px'}}>
      <Header title={t('translations:ABOUT_CARD_TITLE')} /> 
      <Stack sx={{mt:4, pl: 5, pr: 5}} spacing={4} display={"flex"} direction="column" alignItems="center">

      <Grid item xs={12}>
        <Grid container spacing={2} direction={"column"} alignItems="center">
          <Grid item xs={12}>
            <Typography variant="h4" component="div">
              {t('translations:ABOUT_HEADER')}
              </Typography>
          </Grid>
          <Grid item xs={12} sx={{mt: 4}}>
            <Grid container>
              <Grid item xs={12} display="flex" direction={"column"} alignItems="center">
                <Typography  variant="h5" component="div">
                {t('translations:ABOUT_TITLE1')}
              </Typography>
              <Grid item xs={12} sx={{mt:3}}>
              <Button className={"aboutButton"} startIcon={<ArrowForwardIcon />}  variant="contained" onClick={() => navigate(AppRoutes.PREDICTIONS)}>
          <Typography>{t('translations:ABOUT_PREDICTION_REDIRECT')}</Typography>
        </Button>
              </Grid>
              <Typography sx={{mt:4}} component="div" textAlign="center">
                {parse(t('translations:ABOUT_BODY1'))}
              </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <Grid container spacing={2} sx={{mt:3}}>
          <Grid item xs={12} md={6}>
            <Card className="aboutCard" sx={{ height: '100%' }}>
              <CardContent style={{textAlign:"center"}}>
                <Typography color="#003a8d" variant="h5" component="div">
                {t('translations:ABOUT_TITLE2')}
                </Typography>
                <Typography sx={{mt: 4}}>
                  {parse(t('translations:ABOUT_BODY2'))}
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4}}>
                  <ListItem sx={{ display: 'list-item' }}><Typography>{parse(t('translations:ABOUT_BODY2_BULLET1'))}</Typography></ListItem>
                  <ListItem sx={{ display: 'list-item' }}><Typography>{parse(t('translations:ABOUT_BODY2_BULLET2'))}</Typography></ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card className="aboutCard" sx={{ height: '100%' }}>
              <CardContent style={{textAlign:"center"}}>
                <Typography color="#003a8d" variant="h5" component="div">
                  {t('translations:ABOUT_TITLE3')}
                </Typography>
                <Typography sx={{mt: 4}}>
                  {parse(t('translations:ABOUT_BODY4'))}
                </Typography>
                <List sx={{ listStyleType: 'disc', pl: 4}}>
                    <ListItem sx={{ display: 'list-item' }}><Typography>{parse(t('translations:ABOUT_BODY3_BULLET1'))}</Typography></ListItem>
                    <ListItem sx={{ display: 'list-item' }}><Typography>{parse(t('translations:ABOUT_BODY3_BULLET2'))}</Typography></ListItem>
                    <ListItem sx={{ display: 'list-item' }}><Typography>{parse(t('translations:ABOUT_BODY3_BULLET3'))}</Typography></ListItem>
                  </List>

              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>

      <Grid item sx={{pt:0, pb:5}} xs={12}>
        <Button className={"aboutButton"} startIcon={<ArrowForwardIcon />}  variant="contained" onClick={() => navigate(AppRoutes.PREDICTIONS)}>
          <Typography>{t('translations:ABOUT_PREDICTION_REDIRECT')}</Typography>
        </Button>
      </Grid>

    </Stack>
    </Card>      
    )
}



export default About;